// extracted by mini-css-extract-plugin
module.exports = {"favorite-wrap":"style_favorite-wrap__2JdoQ","in-favorite":"style_in-favorite__3h1tZ"};